export default __webpack_public_path__ + "static/media/reload.4cb220ca.svg";